import SidePage from '../../../../../../shared/SidePage'
import { IMaintenanceBlankSchema } from '../../../maintenance.types.ts'
import { useState } from 'react'
import ViewMaintenanceBlankSidePageContent from '@/pages/Processes/Maintenance/MaintenanceBlanks/components/MaintenanceBlankSidePage/ViewMaintenanceBlankSidePageContent'
import EditMaintenanceBlankSidePageContent from '@/pages/Processes/Maintenance/MaintenanceBlanks/components/MaintenanceBlankSidePage/EditMaintenanceBlankSidePageContent'

interface IProps {
  onClose: () => void
  onCloseAnimationEnd?: () => void
  id: IMaintenanceBlankSchema['id']
  open: boolean
}

const MaintenanceBlankSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    if (pageMode === 'edit') {
      return <EditMaintenanceBlankSidePageContent blankId={props.id} onCancel={() => setPageMode('view')} />
    }

    return (
      <ViewMaintenanceBlankSidePageContent id={props.id} onEdit={() => setPageMode('edit')} onClose={props.onClose} />
    )
  }

  return (
    <SidePage
      onClose={props.onClose}
      open={props.open}
      onCloseAnimationEnd={props.onCloseAnimationEnd}
      style={{ paddingRight: 0 }}
      size="large"
    >
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.id) return null

  return <MaintenanceBlankSidePage {...props} />
}
